// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_a3dd3a1","container":"_407d5cb","avatarContainer":"_7735801","avatar":"_b4a246d","remaining":"_f1f48e6","tooltip":"_c28e97a","loader":"_b7247d7"};